export default "14e0710f90470fc8.svg"